import { render, staticRenderFns } from "./AppFooter.vue?vue&type=template&id=b61be3b8&scoped=true&"
var script = {}
import style0 from "./AppFooter.vue?vue&type=style&index=0&id=b61be3b8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b61be3b8",
  null
  
)

export default component.exports